import Cookies from 'js-cookie'

import {
    LoanJourney,
    LoanJourneyCategoryType,
    LoanStepType,
} from '@appTypes/InscalarEvents.interface'

interface CookieYesConsent {
    advertisement?: string
    analytics?: string
    consent?: string
    functional?: string
    necessary?: string
    performance?: string
}

export const parseCookieYesConsent = (
    cookieValue: string
): CookieYesConsent => {
    return Object.fromEntries(
        cookieValue.split(',').map(pair => pair.split(':'))
    ) as CookieYesConsent
}

export const getHasAnalyticsConsent = (consent: CookieYesConsent): boolean => {
    return consent.consent === 'yes' && consent.analytics === 'yes'
}

export const getCookieYesConsent = (): CookieYesConsent | null => {
    const cookieValue = Cookies.get('cookieyes-consent')
    if (!cookieValue) return null
    return parseCookieYesConsent(cookieValue)
}

export const getJourneyFromUrl = (url: string): LoanJourney => {
    if (url.includes('homeowner')) return 'homeowner_loans'
    if (url.includes('credit-cards')) return 'credit_cards'
    return 'personal_loans'
}

export const getJourneyCategoryFromJourney = (
    currentJourney: LoanJourney
): LoanJourneyCategoryType => {
    return currentJourney === 'credit_cards' ? 'credit_cards' : 'loans'
}

export const getStepFromUrl = (url: string): LoanStepType => {
    return url.includes('/all-loans/') ? 'scored_results' : 'unscored_results'
}

const ORIGINAL_JOURNEY_KEY = 'inscalar_original_journey'
const ORIGINAL_JOURNEY_CATEGORY_KEY = 'inscalar_original_journey_category'

type JourneyType = LoanJourney

interface OriginalJourneyData {
    journey: JourneyType
    journeyCategory: LoanJourneyCategoryType
}

export const getOriginalJourney = (): OriginalJourneyData | null => {
    if (typeof window === 'undefined') return null

    const journey = sessionStorage.getItem(ORIGINAL_JOURNEY_KEY) as JourneyType
    const journeyCategory = sessionStorage.getItem(
        ORIGINAL_JOURNEY_CATEGORY_KEY
    ) as LoanJourneyCategoryType | null

    if (!journey || !journeyCategory) return null

    return { journey, journeyCategory }
}

export const setOriginalJourney = (data: OriginalJourneyData): void => {
    if (typeof window === 'undefined') return

    const existing = getOriginalJourney()
    if (existing) return

    sessionStorage.setItem(ORIGINAL_JOURNEY_KEY, data.journey)
    sessionStorage.setItem(ORIGINAL_JOURNEY_CATEGORY_KEY, data.journeyCategory)
}

export const getOrSetOriginalJourney = (
    currentJourney: JourneyType,
    currentJourneyCategory: LoanJourneyCategoryType
): OriginalJourneyData => {
    const existing = getOriginalJourney()

    if (existing) {
        return existing
    }

    const newData: OriginalJourneyData = {
        journey: currentJourney,
        journeyCategory: currentJourneyCategory,
    }

    setOriginalJourney(newData)
    return newData
}
